import React from 'react';
import { IconWrapper } from '..';

export const IconNavigationLeftOutline = IconWrapper(
    (
        upperProps: React.SVGProps<SVGSVGElement> & {
            secondaryColor?: string;
        },
    ) => {
        const { secondaryColor, ...props } = upperProps;
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.414 13l6.293 6.293-1.414 1.414L2.586 12l8.707-8.707 1.414 1.414L6.414 11H21v2H6.414z"
                    fill="currentColor"
                />
            </svg>
        );
    },
);
